import type { Locale } from "@/i18n/routing";

export interface LocaleMeta {
  readonly code: Locale;
  /** 해당 언어의 원어 표기 (예: "한국어", "English", "العربية") */
  readonly nativeName: string;
  /** 약어 라벨 (예: "KO", "EN") */
  readonly shortLabel: string;
  /** 텍스트 방향 */
  readonly dir: "ltr" | "rtl";
}

export const LOCALE_META: readonly LocaleMeta[] = [
  { code: "ko", nativeName: "한국어", shortLabel: "KO", dir: "ltr" },
  { code: "en", nativeName: "English", shortLabel: "EN", dir: "ltr" },
  { code: "ja", nativeName: "日本語", shortLabel: "JA", dir: "ltr" },
  { code: "zh", nativeName: "中文", shortLabel: "ZH", dir: "ltr" },
  { code: "ar", nativeName: "العربية", shortLabel: "AR", dir: "rtl" },
  { code: "he", nativeName: "עברית", shortLabel: "HE", dir: "rtl" },
] as const;
